// extracted by mini-css-extract-plugin
module.exports = {"mock-text-container":"mock_text__mock-text-container___3gSqM","mock-text-aligner":"mock_text__mock-text-aligner___2f1S0","mock-text":"mock_text__mock-text___3-He-"};